module.exports = __webpack_public_path__ + "img/Engie_120X35.5b890065.png";